import { ApiClientBase } from "api/ApiClientBase";

class PersonsApiClient extends ApiClientBase {
    getContext() {
        return this.get(`/api/v1/persons/context`).then((r) => r.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PersonsApiClient();
